import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="bg-sand py-24 lg:py-32" data-id="element-44" data-mp="1lc1xz6j6wro0">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 sm:px-8 lg:grid-cols-12 lg:gap-16" data-id="element-45" data-mp="1ge0g2oxi2ye4">
        <div className="lg:col-span-4" data-id="element-46" data-mp="2dzejrehj0vg9">
          <p className="text-[15px] font-medium text-muted" data-id="element-47" data-mp="2dy3jhonai5tw">Questions fréquentes</p>
          <h2 id="faq-title" className="mt-4 font-display text-4xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-5xl" data-id="element-48" data-mp="2924mxdrt5hie">
            Avant de travailler ensemble.
          </h2>
        </div>

        <div className="lg:col-span-8" data-id="element-49" data-mp="1z59rj3qtzx8c">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.question} className="border-b border-line first:border-t" data-id="element-50" data-mp="noa3wlffi6kn" data-mpi={i}>
                <h3 data-id="element-51" data-mp="phy0xiwrfztd">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-6 py-6 text-left" data-id="element-52" data-mp="phefvtbtcvb4">
                    <span className="font-display text-xl font-semibold text-ink" data-id="element-53" data-mp="khjq5t3rybrn">{f.question}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-ink transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} data-id="element-54" data-mp="6qoi2j13nyp4" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-55" data-mp="3swtp4scdb0v7">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-56" data-mp="1smwnrg7bnah">
                      <p className="max-w-2xl pb-6 text-[17px] leading-relaxed text-muted" data-id="element-57" data-mp="1poteommbj76c">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}